import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  SellerCentralProxyApiFactory,
  type SellerRegistrationV2Dto,
} from '@redteclab/api/clients/composition-service-marketplace'

import { useGlooApi } from '../../../api'
import { useGlobalConfigContext } from '../../../global-config'
import { useMarketplacePartnerRegisterPageContext } from '../../components/marketplacePartnerRegisterPageContext'

const getMarketplacePartnerRegisterApiSwrSendEmailKey = (): string => {
  return 'marketplacePartnerRegisterApiSwrSendEmail'
}

export const useMarketplacePartnerRegisterPageFormApiPostMutationV3WithBody =
  (): SWRMutationResponse<void, unknown, string, SellerRegistrationV2Dto> => {
    const client = useGlooApi(SellerCentralProxyApiFactory)
    const config = useGlobalConfigContext()
    const { setIsFormSubmitted } = useMarketplacePartnerRegisterPageContext()

    return useSWRMutation(
      getMarketplacePartnerRegisterApiSwrSendEmailKey(),
      async (
        _key,
        { arg }: { arg: SellerRegistrationV2Dto },
      ): Promise<void> => {
        await client.compositionServiceMarketplaceApiSellerV3Register({
          language: config.language,
          SellerRegistrationV2Dto: arg,
          tenant: config.tenantAndEnv,
        })
      },
      {
        onSuccess: () => {
          setIsFormSubmitted(true)
        },
      },
    )
  }
